import api from './api'
import type { Post, PostListItem, PostInput } from '../types'

export const postsService = {
  // Authenticated endpoints (for blog owner)
  async getAllPosts(): Promise<PostListItem[]> {
    const response = await api.get('/posts')
    return response.data.posts
  },

  async getPost(id: number): Promise<Post> {
    const response = await api.get(`/posts/${id}`)
    return response.data.post
  },

  async createPost(data: PostInput): Promise<Post> {
    const response = await api.post('/posts', { post: data })
    return response.data.post
  },

  async updatePost(id: number, data: PostInput): Promise<Post> {
    const response = await api.patch(`/posts/${id}`, { post: data })
    return response.data.post
  },

  async deletePost(id: number): Promise<void> {
    await api.delete(`/posts/${id}`)
  },

  async publishPost(id: number): Promise<Post> {
    const response = await api.post(`/posts/${id}/publish`)
    return response.data.post
  },

  async unpublishPost(id: number): Promise<Post> {
    const response = await api.post(`/posts/${id}/unpublish`)
    return response.data.post
  },

  async uploadCoverImage(id: number, file: File): Promise<Post> {
    const formData = new FormData()
    formData.append('image', file)
    const response = await api.post(`/posts/${id}/cover_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data.post
  },

  async removeCoverImage(id: number): Promise<Post> {
    const response = await api.delete(`/posts/${id}/cover_image`)
    return response.data.post
  },

  // Public endpoints (for viewing blog)
  async getPublicPosts(username: string): Promise<PostListItem[]> {
    const response = await api.get(`/profiles/${username}/posts`)
    return response.data.posts
  },

  async getPublicPost(username: string, slug: string): Promise<Post> {
    const response = await api.get(`/profiles/${username}/posts/${slug}`)
    return response.data.post
  },
}
